import { Button, Card, Modal, Table } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
// import { faGoogle } from "@fortawesome/free-brands-svg-icons"
import { useState } from 'react'
import useCallApi from '../../../../../hooks/useCallApi'
import Loading from '../../../../../templates/UI/Loading/Loading'
import getCampaignStatus from '../../../../../helpers/getCampaignStatus'
import LPModal from './LPModal'
import callAPI from '../../../../../helpers/callAPI'
import TestLinksModal from './TestLinks'
import ScreenshotsModal from './Screenshots'
import { FaExternalLinkAlt, FaLink, FaGoogle } from 'react-icons/fa'
import HostAndPost from './HostAndPost'
import ReactTooltip from 'react-tooltip'

const LandingPages = ({ showSystemMessage, campaign, campaignId }) => {
    const { dataLoaded, data, setData, refetch } = useCallApi(`campaign/${campaignId}/landingPages`, 'GET', {}, [campaignId])
    const [campaignData, setCampaignData] = useState(campaign)
    const [tLIsOpen, setTLIsOpen] = useState(false)
    const [isOpen, setIsOpen] = useState(false)
    const [ssIsOpen, setSSIsOpen] = useState(false)
    const [hpIsOpen, setHPIsOpen] = useState(false)
    // const [isCreate, setIsCreate] = useState(true)
    const [selectedLP, setSelectedLP] = useState(false)
    const [selectedLPId, setSelectedLPId] = useState(0)
    const [deleteId, setDeleteId] = useState(-1)

    const deleteLandingPage = async (id) => {
        const response = await callAPI(`campaign/${campaignId}/landingPages/${id}`, 'DELETE', {}, 'DELETE')
        if (response.success) {
            showSystemMessage('success', 'Landing Page Deleted')
            refetch()
        } else {
            showSystemMessage('danger', response.errors.message)
        }
    }

    return (
        <Card className="mb-2">
            <ScreenshotsModal isOpen={ssIsOpen} setIsOpen={setSSIsOpen} showSystemMessage={showSystemMessage} refetch={refetch} campaignId={campaignId} landingPages={data.landingPages} campaignData={campaignData} selectedLP={selectedLP} dataLoaded={dataLoaded} />
            <TestLinksModal isOpen={tLIsOpen} setIsOpen={setTLIsOpen} campaignId={campaignId} landingPages={data.landingPages} campaignData={campaignData} dataLoaded={dataLoaded} />

            {isOpen && <LPModal setIsOpen={setIsOpen} isOpen={isOpen} showSystemMessage={showSystemMessage} refetch={refetch} campaignId={campaignId} selectedLPId={selectedLPId} selectedLP={selectedLP} landingPages={data.landingPages} />}

            <Modal
                size="xl"
                show={hpIsOpen}
                onHide={() => {
                    setHPIsOpen(false)
                }}
            >
                <HostAndPost isOpen={hpIsOpen} setIsOpen={setHPIsOpen} showSystemMessage={showSystemMessage} refetch={refetch} campaignId={campaignId} landingPages={data.landingPages} campaignData={campaignData} dataLoaded={dataLoaded} />
            </Modal>
            <Card.Header className="d-flex justify-content-between align-items-center">
                <div>Landing Pages</div>
                <div>
                    <Button
                        variant="warning"
                        size="sm"
                        onClick={() => {
                            setSelectedLPId(0)
                            setIsOpen(true)
                        }}
                    >
                        Add Landing Page
                    </Button>
                    <Button
                        variant="warning"
                        size="sm"
                        className="ml-2"
                        onClick={() => {
                            setTLIsOpen(true)
                        }}
                    >
                        Generate Test Links
                    </Button>
                    {campaignData.type.value === 'H' && (
                        <Button
                            variant="warning"
                            size="sm"
                            className="ml-2"
                            onClick={() => {
                                setHPIsOpen(true)
                            }}
                        >
                            POST Settings
                        </Button>
                    )}
                </div>
            </Card.Header>
            <Table striped bordered hover>
                <thead>
                    <tr>
                        <td>ID</td>
                        <td>Name</td>
                        <td>Status</td>
                        <td>Default</td>
                        <td></td>
                        <td></td>
                    </tr>
                </thead>
                {dataLoaded ? (
                    <tbody>
                        <ReactTooltip />
                        {data.landingPages.map((page, index) => (
                            <tr key={index}>
                                <td>{page.lp_record_id}</td>
                                <td className="align-items-center">{page.lp_name}
                                    {page.safesearch_enabled
                                        ? <span className="text-danger ml-2"><FaGoogle data-tip="Safesearch" size={10} /></span>
                                        : null}
                                    {page.allows_deeplink?.trim() === 'Y'
                                        ? <span className="text-danger ml-2"><FaLink data-tip="Deeplink" size={10} /></span>
                                        : null}
                                </td>
                                <td>{getCampaignStatus(page.lp_status)}</td>
                                <td>{page.lp_default_flag === 'Y' ? 'Yes' : 'No'}</td>
                                <td width="20%">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <a target="_blank" rel="noopener noreferrer" className="mr-2" href={page.lp_landing_url}>
                                            <FaExternalLinkAlt /> View LP
                                        </a>
                                        <div>
                                            <Button
                                                onClick={() => {
                                                    setSelectedLPId(page.lp_record_id)
                                                    setIsOpen(true)
                                                }}
                                                variant="warning"
                                                size="sm"
                                            >
                                                Edit
                                            </Button>
                                            {page.lp_default_flag === 'N' && (
                                                <>
                                                    {deleteId !== page.lp_record_id ? (
                                                        <Button variant="outline-danger" size="sm" className="ml-2" onClick={() => setDeleteId(page.lp_record_id)}>
                                                            Delete
                                                        </Button>
                                                    ) : (
                                                        <Button variant="danger" size="sm" className="ml-2" onClick={() => deleteLandingPage(page.lp_record_id)}>
                                                            Confirm
                                                        </Button>
                                                    )}
                                                </>
                                            )}
                                        </div>
                                    </div>
                                </td>
                                <td width="15%">
                                    <Button
                                        variant="warning"
                                        size="sm"
                                        onClick={() => {
                                            setSelectedLP({
                                                lp_record_id: page.lp_record_id,
                                                lp_name: page.lp_name,
                                                lp_landing_url: page.lp_landing_url,
                                                lp_default_flag: page.lp_default_flag,
                                                lp_status: page.lp_status,
                                            })
                                            setSSIsOpen(true)
                                        }}
                                    >
                                        Screenshots
                                    </Button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                ) : (
                    <tbody>
                        <tr>
                            <td colSpan={6}>
                                <Loading />
                            </td>
                        </tr>
                    </tbody>
                )}
            </Table>
        </Card>
    )
}

export default LandingPages

